import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RequestQuoteApiService } from '@shared/modals/request-quote/request-quote-api.service';
import { RequestQuoteComponent } from './request-quote.component';
import { QuoteDetailsComponent } from './components/quote-details/quote-details.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
    exports: [RequestQuoteComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        RequestQuoteComponent, QuoteDetailsComponent
    ],
    providers: [
        RequestQuoteApiService
    ]
})
export class RequestQuoteModule {
}
